import { render } from "./contact.info.item.vue?vue&type=template&id=8f54dd82&scoped=true"
import script from "./contact.info.item.vue?vue&type=script&lang=js"
export * from "./contact.info.item.vue?vue&type=script&lang=js"

import "./contact.info.item.vue?vue&type=style&index=0&id=8f54dd82&scoped=true&lang=css"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f54dd82"]])

export default __exports__